$("document").ready(function() {
  /* Js for Product page Mobile accordion Section*/
 $(".accordion-inner-part .accordion-head").click(function() {

    if ($('.accordion-body').is(':visible')) {
      $(".accordion-body").slideUp(300);
      // $(".plusminus").text('+');
        $(".accordion-head").removeClass("active");
    }
    if ($(this).next(".accordion-body").is(':visible')) {
      $(this).next(".accordion-body").slideUp(300);
      // $(this).children(".plusminus").text('+');
          $(this).removeClass("active");
    } else {
      $(this).next(".accordion-body").slideDown(300);
      // $(this).children(".plusminus").text('-');
       
       $(this).addClass("active");
    }
  });

});